import { IAlbum } from "../../common/Album";

const album: IAlbum = {
  title: "Seasonal Sasquatch Sightings",
  date: new Date(2024, 5, 2),
  img: "/img/joker.jpeg",
  tracks: [
    {
      title: 'Tasty Snack',
      src: '/songs/2024-06-02/tasty_snack.mp3',
      duration: 440.904
    },
    {
      title: 'Read Between The Lines',
      src: '/songs/2024-06-02/read_between_the_lines.mp3',
      duration: 563.424
    },
    {
      title: 'Escapade',
      src: '/songs/2024-06-02/escapade.mp3',
      duration: 1482.528
    },
    {
      title: 'Next Day Shipping',
      src: '/songs/2024-06-02/next_day_shipping.mp3',
      duration: 546.144
    },
    {
      title: 'Stay The Night',
      src: '/songs/2024-06-02/stay_the_night.mp3',
      duration: 791.304
    },
    {
      title: 'Who Can Come (And Eat The Cheese)?',
      src: '/songs/2024-06-02/who_can_come.mp3',
      duration: 917.592
    },
    {
      title: 'Thank You Joan Jett',
      src: '/songs/2024-06-02/thank_you_joan_jett.mp3',
      duration: 876.096
    },
    {
      title: 'Dance All Night',
      src: '/songs/2024-06-02/dance_all_night.mp3',
      duration: 522.48
    },
    {
      title: 'Jack & Jill Nicholson',
      src: '/songs/2024-06-02/jack_and_jill_nicholson.mp3',
      duration: 914.664
    },
    {
      title: 'Turning Point',
      src: '/songs/2024-06-02/turning_point.mp3',
      duration: 600.744
    },
    {
      title: 'Secret Meeting Place',
      src: '/songs/2024-06-02/secret_meeting_place.mp3',
      duration: 769.752
    },
    {
      title: 'Oh, Boy',
      src: '/songs/2024-06-02/oh_boy.mp3',
      duration: 343.584
    },
    {
      title: 'Come And Get It',
      src: '/songs/2024-06-02/come_and_get_it.mp3',
      duration: 659.424
    },
    {
      title: "The Devil Ain't Your Friend",
      src: '/songs/2024-06-02/the_devil_aint_your_friend.mp3',
      duration: 253.44
    }
  ]
};
export default album;
